import T from 'prop-types';
import React, { Component } from 'react';
import { TextInput } from '@acast/decibel';
import getShortURL from 'shared/helpers/get-short-url';

export default class ShortURLGenerator extends Component {
  static propTypes = {
    showUrl: T.string.isRequired,
    episodeUrl: T.string.isRequired,
  };

  state = {
    shortUrl: null,
    pending: true,
  };

  componentDidMount() {
    const { showUrl, episodeUrl } = this.props;

    getShortURL(showUrl, episodeUrl)
      .then(result => {
        this.setState({ pending: false, shortUrl: result });
      })
      .catch(() => {
        this.setState({ pending: false, shortUrl: 'Error retrieving URL.' });
      });
  }

  render() {
    const { shortUrl, pending } = this.state;

    return <TextInput value={shortUrl || ''} readOnly busy={pending} />;
  }
}
